/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useContext, useRef } from 'react';
import { Auth } from 'aws-amplify';
import { useHistory, useLocation, Link } from 'react-router-dom';
import moment from 'moment';
import Cookies from 'universal-cookie';
import classNames from 'classnames';

import { OverlayPanel } from 'primereact/overlaypanel';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';

import { UserDetailsContext, useUserDetailsContext } from 'context/userDetailsContext';
import { markNotification, clearNotifications, resetNotificationCount } from 'services/notification/notificationService';
import { loginLogoutEvent } from 'services/generalServices';
import { getUserProfileDetails } from 'services/profileServices';
import { getCurrentTagIn } from 'services/tagInServices';
import { WebSocketConnectionContext } from 'context/WebSocketConnectionContext';
import { openLinkInBlank, getTenantDetails, firmSelectHandler, logout, extractCaseId } from 'utils/utils';
import { toastConstant } from 'constants/toastmessage';
import { presignedURLGet } from 'modules/file_manager/services';
import { createTemplate } from 'modules/templates/services';
import { uuidv4 } from 'common/uuidGenerator';
import { useNavbarContext } from 'context/NavbarContext';
import { ModalHeader } from 'shared/ModalHeader';
import { Notification } from './components/Notification/Notification';
import { NotificationPopup } from 'components/NotificationPopup/NotificationPopup';
import { useToast } from 'context/ToastContext';
import constants from 'constants/index';
import useSpinner from 'hooks/useSpinner';
import GlobalSearch from './components/GlobalSearch/GlobalSearch';
import AnnouncementsBar from 'shared/AnnouncementsBar/AnnouncementsBar';
import { useAnnouncements } from 'hooks/useAnnouncements';
import logo from '../../assets/images/Full_Logo_Black.svg';
import logodark from '../../assets/images/Full_Logo_White.svg';
import GlobalTooltip from 'components/GlobalTooltip';
import { appVersion } from 'config/app_version';

import { default as InfiniteScrollList } from 'components/InfiniteScrollNotificationList/InfiniteScrollNotificationList';
import useDynamicHeight from 'components/UI/NavbarHeight/useDynamicHeight';
import { useDataProvider } from 'context/DataProviderContext';
import TimerManager from './components/TimerManager/TimerManager';
import TextSnippetWrapper from 'components/TextSnippetWrapper';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { customHeaderTemplate } from 'modules/settings/SettingHelper';
import { useQueryClient } from '@tanstack/react-query';

const cookie = new Cookies();
export const UserProfileContext = React.createContext();
const Layout = ({ children, showSideBar }) => {
  const { data: announcementsData, loading: announcementsLoading } = useAnnouncements(20);
  const [tenantId, tenantSk] = getTenantDetails();
  const { checkSubPermission } = useUserDetailsContext();

  const menu = useRef(null);
  const fileMenu = useRef(null);
  const messagesMenu = useRef(null);
  const history = useHistory();
  const [userInfo, setUserInfo] = useState('');
  const [navigationToggle, setNavigationToggle] = useState(false);
  const userDetails = useUserDetailsContext();
  const { imageUrl, setImageUrl, lastFetchedTenantKey, setLastFetchedTenantKey } = useUserDetailsContext();
  const websocketContext = useContext(WebSocketConnectionContext);
  const notificationPanel = useRef('');
  const { addToast } = useToast();
  const { pathname } = useLocation();
  const { clearAllData } = useDataProvider();
  const queryClient = useQueryClient();

  const userContext = useContext(UserDetailsContext);
  const navbarContextData = useNavbarContext();

  const [currentToken, setCurrentToken] = useState('');
  const [spinner, showSpinner, hideSpinner] = useSpinner(true);
  const [newNotification, setNewNotification] = useState(false);
  const [toggleVal, setToggleVal] = useState(false);
  const [isFileVisible, setFileVisible] = useState(false);
  const [disableMenu, setDisableMenu] = useState(false);
  const [webSocketNotificationsCount, setWebSocketNotificationsCount] = useState(0);
  const [isTagInActive, setIsTagInActive] = useState(false);
  const [showNotificationPopup, setShowNotificationPopup] = useState(false);
  const [notificationPopupData, setNotificationPopupData] = useState(null);
  const [notificationFilter, setNotificationFilter] = useState('unread'); // 'unread', 'read'
  const [nameModal, setNameModal] = useState(false);

  // Use sessionStorage to persist shown notifications across navigations
  const getShownNotifications = () => {
    try {
      const stored = sessionStorage.getItem('shownNotifications');
      return stored ? new Set(JSON.parse(stored)) : new Set();
    } catch {
      return new Set();
    }
  };

  const addShownNotification = (id) => {
    try {
      const shown = getShownNotifications();
      shown.add(id);
      sessionStorage.setItem('shownNotifications', JSON.stringify([...shown]));
    } catch (error) {
      console.error('Error saving shown notification:', error);
    }
  };

  const {
    notifications: notificationList = [],
    next_token: nextToken,
    total_notifications,
  } = navbarContextData?.notificationData?.notifications || {};

  const { isLoading, setNotifications: setNotificationList } = navbarContextData?.notificationData || {};

  const secureMessageNotificationCount = Number(navbarContextData?.notificationData?.notificationCount?.thread_count);
  const texMessageNotificationcount = Number(navbarContextData?.notificationData?.notificationCount?.text_message_count);
  const mailNotificationCount = Number(navbarContextData?.notificationData?.notificationCount?.email_count);
  const sidebarNotificationCount = Number(navbarContextData?.notificationData?.notificationCount?.chat_read_count);
  const textMessageFilterActive = navbarContextData?.textMessageFilterActive || false;

  const loggedInUserId = cookie.get('userId') || null;

  const totalNotiicationsCount = Number(webSocketNotificationsCount || 0) || Number(total_notifications || 0) || 0;
  const { dynamicHeight } = useDynamicHeight();
  const profileMenu = useRef(null);

  const documentItems = [
    {
      label: 'File Manager',
      url: '#/file-manager',
      command: () => {
        if (!openLinkInBlank('/file-manager')) {
          window.location.hash = '/file-manager';
          setNavigationToggle(false);
        }
      },
      show: true,
    },
    {
      label: 'Templates',
      url: '#/templates',
      command: () => {
        if (!openLinkInBlank('/templates')) {
          window.location.hash = '/templates';
          setNavigationToggle(false);
        }
      },
      show: userDetails.checkSubPermission('document_assembly'),
    },
  ];
  const messageItemsFirmAdmin = [
    {
      label: 'Secure Messages',
      command: () => {
        if (!openLinkInBlank('/messages')) {
          window.location.hash = '/messages';
          setNavigationToggle(false);
          messagesMenu.current.hide();
        }
      },
      template: (item) => {
        return (
          <Link
            className="notification-textmsg black-600 cursor-pointer d-flex align-items-center text-decoration-none"
            onClick={() => {
              if (!openLinkInBlank('/messages')) {
                setNavigationToggle(false);
                messagesMenu.current.hide();
              }
            }}
            to="/messages"
          >
            <span>{item.label}</span>

            <div className="d-inline-flex message-status">
              {secureMessageNotificationCount > 0 ? (
                <i className="icon-messages me-3 ms-3 new-message-notification">
                  <span className="p-badge">{secureMessageNotificationCount}</span>
                </i>
              ) : (
                <i className="icon-messages me-2 ms-2 new-message-notification"></i>
              )}
              {sidebarNotificationCount > 0 ? (
                <i className="icon-sidebar">
                  <span className="p-badge">{sidebarNotificationCount}</span>
                </i>
              ) : (
                <i className="icon-sidebar"></i>
              )}
              {isTagInActive && (
                <GlobalTooltip tooltip="You have a teammate tagged in." showDelay={300}>
                  <i
                    className="fas fa-tags ms-2 pointer F-size12"
                    style={{
                      color: '#2b5eca',
                      filter: 'drop-shadow(0 0 2px rgba(43, 94, 202, 0.5))',
                      animation: 'pulse 2s infinite',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      item.tagInCommand();
                    }}
                  />
                </GlobalTooltip>
              )}
            </div>
          </Link>
        );
      },
      tagInCommand: () => {
        if (!openLinkInBlank('/profile')) {
          history.push({
            pathname: '/profile',
            state: { manageNotification: true },
          });
          setNavigationToggle(false);
          messagesMenu.current.hide();
        }
      },
      show: true,
    },
    {
      label: `Text Messages`,
      command: () => {
        if (!openLinkInBlank('/text-messages')) {
          window.location.hash = '/text-messages';
          setNavigationToggle(false);
          messagesMenu.current.hide();
        }
      },
      template: (item) => {
        return (
          <>
            <Link
              to="/text-messages"
              onClick={(e) => {
                if (!openLinkInBlank('/text-messages')) {
                  setNavigationToggle(false);
                  messagesMenu.current.hide();
                }
              }}
              className="text-decoration-none"
            >
              <div className="notification-textmsg black-600 cursor-pointer">
                <span>{item.label}</span>
                {textMessageFilterActive && texMessageNotificationcount > 0 ? (
                  <span
                    className="p-badge mt-1 text-msg-filtered-badge"
                    data-pr-tooltip="Filtered unread count for selected practice areas"
                    data-pr-position="right"
                  >
                    {texMessageNotificationcount}
                  </span>
                ) : (
                  <span className={texMessageNotificationcount > 0 ? 'p-badge mt-1' : ''}>
                    {texMessageNotificationcount > 0 ? texMessageNotificationcount : null}
                  </span>
                )}
              </div>
            </Link>
            {textMessageFilterActive && texMessageNotificationcount > 0 && <Tooltip target=".text-msg-filtered-badge" showDelay={300} />}
          </>
        );
      },
      show: userDetails.checkSubPermission('texting'),
    },
    checkSubPermission('email_service') && {
      label: 'Mail',
      command: () => {
        if (!openLinkInBlank('/mails')) {
          window.location.hash = '/mails';
          setNavigationToggle(false);
          messagesMenu.current.hide();
        }
      },
      template: (item) => {
        return (
          <Link
            to="/mails"
            className="text-decoration-none"
            onClick={(e) => {
              if (!openLinkInBlank('/mails')) {
                setNavigationToggle(false);
                messagesMenu.current.hide();
              }
            }}
          >
            <div className="notification-textmsg black-600 cursor-pointer">
              <span>{item.label}</span>
              <span className={mailNotificationCount > 0 ? 'p-badge mt-1' : ''}>
                {mailNotificationCount > 0 ? mailNotificationCount : null}
              </span>
            </div>
          </Link>
        );
      },
      show: !!userDetails?.userDetails?.business_email,
    },
    checkSubPermission('fax_integration') && {
      label: 'Fax',
      command: () => {
        if (!openLinkInBlank('/fax')) {
          window.location.hash = '/fax';
          setNavigationToggle(false);
          messagesMenu.current.hide();
        }
      },
      template: (item) => {
        return (
          <Link
            className="text-decoration-none"
            to="/fax"
            onClick={(e) => {
              if (!openLinkInBlank('/fax')) {
                setNavigationToggle(false);
                messagesMenu.current.hide();
              }
            }}
          >
            <div className="notification-textmsg black-600 cursor-pointer">
              <span>{item.label}</span>
            </div>
          </Link>
        );
      },
      show: userDetails.checkSubPermission('fax_integration'),
    },
  ];

  const items = [
    {
      label: 'New Case',
      icon: 'icon-doc-add',
      url: '/#/cases?createTask=true',
      show: true,
    },
    {
      label: 'New File',
      icon: 'icon-files',
      show: true,
      template: (item, options) => (
        <div className="p-menuitem-link" onClick={() => setFileVisible(true)}>
          <span className={`p-menuitem-icon ${item.icon}`} />
          <span className="p-menuitem-text">{item.label}</span>
        </div>
      ),
    },
    {
      label: 'New Contact',
      icon: 'icon-contacts',
      url: '/#/contacts/add',
      show: true,
    },
    {
      label: 'New Lead',
      icon: 'icon-person',
      url: '/#/leads/new',
      show: userContext.checkSubPermission('lead_management'),
    },
    {
      label: 'New Event',
      icon: 'icon-calendar',
      url: '/#/calendar?createEvent=true',
      show: true,
    },
    {
      label: 'New Task',
      icon: 'icon-tasks',
      url: '/#/tasks?openTask=true',
      show: userContext.checkSubPermission('task_management'),
    },
    {
      label: 'Message',
      icon: 'icon-messages',
      url: '/#/messages?createMessage=true',
      show: true,
    },
    {
      label: 'New Time Entry',
      icon: 'icon-clock',
      show: true,
      url: extractCaseId(pathname)
        ? `/#/cases/${extractCaseId(pathname)}/billing?tab_id=2&createTimeEntry=1`
        : `/#/reports/time-manager?createTimeEntry=1`,
    },
    {
      label: 'Add Note',
      icon: 'icon-notes',
      url: `/#/notes?type=case_note&companion_link=false`,
      show: true,
    },
    {
      label: 'Add Call Log',
      icon: 'icon-notes',
      url: `/#/notes?type=call_log&companion_link=false`,
      show: true,
    },
    {
      label: 'Add Quick Lead',
      icon: 'icon-notes',
      url: '/#/quick-leads',
      show: true,
    },
  ];

  const fetchUserDetails = () => {
    getUserProfileDetails()
      .then((response) => {
        if (response && response.data) {
          fetchImage(response?.data?.profile_image);
        }
      })
      .catch((error) => {});
  };

  // Check if tag-in is active for the logged-in user
  const checkTagInStatus = async () => {
    try {
      // Pass true to excludeFromLoading to avoid loader
      const response = await getCurrentTagIn(true);
      const active = Boolean(response?.data?.is_active);
      setIsTagInActive(active);
    } catch (err) {
      setIsTagInActive(false);
      console.log('[TagIn] checkTagInStatus error:', err);
    }
  };

  const getUserDetails = () => {
    try {
      Auth.currentUserInfo()
        .then((res) => {
          localStorage.setItem('userInfo', JSON.stringify(res));
          setUserInfo(res);
        })
        .catch((error) => {
          localStorage.setItem('userInfo', null);
        });
    } catch (e) {
      localStorage.setItem('userInfo', null);
      console.log(e);
    }
  };

  const redirectToPage = (e, path) => {
    e.preventDefault();
    if (!openLinkInBlank(path)) {
      history.push(path);
      setNavigationToggle(false);
    }
  };

  // const redirectToDashboardPage = (e) => {
  //   e.preventDefault();
  //   if (!openLinkInBlank('/dashboard')) {
  //     history.push('/dashboard');
  //     setNavigationToggle(false);
  //   }
  // };

  const redirectToCases = () => {
    if (!openLinkInBlank('/cases')) {
      setNavigationToggle(false);
    }
  };

  const handleProfile = (e) => {
    redirectToPage(e, '/profile');
  };

  const handleLogout = () => {
    try {
      clearAllData();
      // Clear React Query cache to prevent stale data on re-login
      queryClient.clear();
      loginLogoutEvent()
        .then((response) => {})
        .catch((err) => {});
      Auth.signOut()
        .then((data) => {
          logout(history);
          websocketContext.closeConnection();
        })
        .catch((error) => {});
    } catch (e) {
      console.error('Error during logout:', e);
    }
  };

  const markAsRead = (e, data) => {
    showSpinner();
    e.preventDefault();
    markNotification(true, [data?.sk])
      .then((response) => {
        // Reload notifications with refresh flag to get accurate count and fresh list
        navbarContextData?.notificationData
          ?.loadNotifications({ notificationType: '', limit: 10, refresh: true })
          .then(() => {
            hideSpinner();
          })
          .catch(() => {
            hideSpinner();
          });
      })
      .catch((err) => {
        console.log('err', err);
        hideSpinner();
      });
  };

  const showModule = (module, subscriptionPermission) => {
    if (!(userContext?.subscriptionAccess?.[subscriptionPermission] || subscriptionPermission === 'common')) {
      return false;
    }
    let permission = userDetails.permissions ? userDetails.permissions[module] : '';
    let response = false;
    if ([constants.permissions.READ, constants.permissions.WRITE].includes(permission)) {
      response = true;
    }
    return response;
  };

  const clearAll = (e) => {
    e.preventDefault();
    showSpinner();
    clearNotifications()
      .then((response) => {
        hideSpinner();
        setWebSocketNotificationsCount(0);
        setNotificationList((preval) => ({ ...preval, notifications: [] }));
        navbarContextData?.notificationData?.setNotifications({});
      })
      .catch((err) => {
        hideSpinner();
      });
  };

  const fetchImage = async (filePath) => {
    try {
      let fileSize = 'medium.jpg';
      if (filePath) {
        let proURL = filePath;
        let url = proURL.split('/');
        url.pop();
        if (fileSize) {
          url.push(fileSize);
        } else {
          url.push('small.jpg');
        }
        let finalUrl = url.join('/');
        let data = await presignedURLGet(finalUrl, false, true, true);
        if (data?.data?.file_url) {
          setToggleVal(!toggleVal);
          setImageUrl(data?.data?.file_url);
        } else {
          setImageUrl('');
        }
      }
    } catch (error) {}
  };

  // const handleFromScratch = () => {
  //   localStorage.removeItem('file_url');
  //   localStorage.removeItem('file_name');
  //   localStorage.removeItem('file_size');
  //   localStorage.removeItem('file_type');
  //   localStorage.setItem('mode', 'scratch');
  //   let new_id = uuidv4();
  //   localStorage.setItem('file_url', `${new_id}.html`);
  //   setFileVisible(false);
  // };

  const newFileSchema = Yup.object().shape({
    file_name: Yup.string().required('File name is required'),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(newFileSchema),
    defaultValues: {
      file_name: '',
    },
  });

  const handleFromScratch = async (data) => {
    setNameModal(false);
    localStorage.removeItem('file_url');
    localStorage.removeItem('file_name');
    localStorage.removeItem('file_size');
    localStorage.removeItem('file_type');
    localStorage.removeItem('sk');
    localStorage.removeItem('pk');
    localStorage.setItem('mode', 'blank');
    let new_id = uuidv4();
    localStorage.setItem('file_url', `${new_id}.zdoc`);

    const tenantId = cookie.get('tenantId') || null;
    let user = await Auth.currentAuthenticatedUser();

    let url_docx = `public/${tenantId}/root/templates/${new_id}.zdoc`;

    let file_details = {
      file_name: data.file_name + '.zdoc',
      display_name: data.file_name,
      size: '',
      file_path: url_docx,
      file_type: 'zdoc',
      created_by: user.attributes,
      version_id: '',
      file_path_docx: url_docx,
      conditional_fields: [],
      practice_area: '',
    };
    let attachments = [];
    attachments.push(file_details);

    let paylaod = {
      type: 'file',
      files: attachments,
      case_id: 'undefined',
      mode: 'blank',
    };
    let response = await createTemplate(paylaod);
    if (response?.data) {
      localStorage.setItem('file_url', response.data.data[0].file_path);
      localStorage.setItem('pk', response.data.data[0].pk);
      localStorage.setItem('sk', response.data.data[0].sk);
      localStorage.setItem('file_name', data.file_name);
      localStorage.setItem('practice_area', '');
      localStorage.setItem('version_id', response.data?.data[0].version_id);
      let pathname = '/templates/builder';
      let state = { type: 'scratch', save_as: 'file' };
      if (!openLinkInBlank(pathname, state)) {
        history.push({
          pathname,
          state,
        });
      }
    }

    setFileVisible(false);
  };

  const redirectToSubscription = () => {
    history.push('/settings/subscription');
  };
  /**--------------------------------------- useEffect section starts ---------------------------------------**/

  useEffect(() => {
    let accessLevel = cookie.get('access_level') || null;
    if (
      accessLevel &&
      accessLevel !== 'firm-admin' &&
      userDetails?.selectedPlanDetails?.message &&
      userDetails?.selectedPlanDetails?.message === constants?.NON_FIRM_ADMIN_SUBSCRIPTION_CANCEL_MESSAGE
    ) {
      handleLogout();
    }
    if (
      userDetails?.selectedPlanDetails?.status &&
      userDetails?.selectedPlanDetails?.access_modules?.subscription &&
      userDetails?.selectedPlanDetails?.status !== 'completed' &&
      !userDetails?.selectedPlanDetails?.access_modules?.dashboard
    ) {
      setDisableMenu(true);
    } else {
      setDisableMenu(false);
    }
  }, [userDetails]); // eslint-disable-line

  useEffect(() => {
    if (tenantId && tenantSk) {
      const currentKey = `${tenantId}:${tenantSk}`;
      if (lastFetchedTenantKey !== currentKey) {
        fetchUserDetails();
        checkTagInStatus();
        setLastFetchedTenantKey(currentKey);
      }
    }
  }, [tenantId, tenantSk]); // eslint-disable-line

  useEffect(() => {
    getUserDetails();
  }, []); //eslint-disable-line

  useEffect(() => {
    if (userDetails && userDetails.access_level) {
      let tenantId = cookie.get('tenantId');
      if (userDetails && userDetails.firmDetails && userDetails.firmDetails.current_user && tenantId) {
        websocketContext.connectToWebSocket(tenantId, userDetails?.firmDetails?.current_user);
      } else if (!tenantId) {
        history.replace('/tenant-selection');
      }
    }
  }, [userDetails]); // eslint-disable-line

  useEffect(() => {
    let notificationsArr = [...notificationList] || [];
    const duplicateData = notificationsArr?.some((item) => item?.sk === websocketContext?.notificationData?.sk);
    if (websocketContext?.notificationData) {
      const notification = websocketContext.notificationData;
      const notificationId = notification?.sk;

      if (
        websocketContext?.notificationData?.notification_type === 'secure_message' &&
        websocketContext?.notificationData?.created_by_user_id &&
        websocketContext?.notificationData?.created_by_user_id === loggedInUserId
      ) {
        return;
      }

      // Add to notification list unless inapp is explicitly false
      if (notification?.inapp !== false) {
        const count = !duplicateData ? total_notifications + 1 : total_notifications;
        setWebSocketNotificationsCount(count);
        if (!duplicateData) {
          notificationsArr.unshift(websocketContext?.notificationData);
          setNewNotification(true);
        }
      }

      if (
        ['inbound_text_message', 'secure_message', 'text_message']?.includes(websocketContext?.notificationData?.notification_type) &&
        loggedInUserId
      ) {
        navbarContextData?.notificationData?.loadNotificationCount();
      }

      // Check if we've already shown toast/popup for this notification
      const shownNotifications = getShownNotifications();
      if (notificationId && !shownNotifications.has(notificationId)) {
        // Handle toast notification (1 minute = 60000ms auto-close)
        if (notification?.toast) {
          addToast(false, toastConstant.toasterType.INFO, toastConstant.api.SUCCESS, '', 'bottom-right', true, notification, 60000);
        }

        // Handle popup notification
        if (notification?.popup) {
          setNotificationPopupData(notification);
          setShowNotificationPopup(true);
        }

        // Mark this notification as shown and clear from context
        if (notification?.toast || notification?.popup) {
          addShownNotification(notificationId);
          // Clear notification data from websocket context to prevent re-triggering
          setTimeout(() => {
            websocketContext?.setNotificationData(null);
          }, 100);
        }
      }
    }

    // Update notification list unless inapp is explicitly false
    if (websocketContext?.notificationData?.inapp !== false) {
      setNotificationList((preval) => ({ ...preval, notifications: notificationsArr }));
    }
  }, [websocketContext?.notificationData]); // eslint-disable-line

  useEffect(() => {
    if (websocketContext?.sideBarMessages) {
      if (
        ['sidebar_message']?.includes(websocketContext?.sideBarMessages?.notification_type) &&
        loggedInUserId !== websocketContext?.sideBarMessages?.created_by_user_id
      ) {
        navbarContextData?.notificationData?.loadNotificationCount();
      }
    }
    if (websocketContext?.caseEmails) {
      if (['incoming_email']?.includes(websocketContext?.caseEmails?.notification_type) && loggedInUserId) {
        navbarContextData?.notificationData?.loadNotificationCount();
      }
    }
  }, [websocketContext?.sideBarMessages, websocketContext?.caseEmails]);

  //Secure message toast message - Showing "Message sent successfully" to the person who sent the message
  useEffect(() => {
    if (
      websocketContext?.secureMessageData &&
      Object.keys(websocketContext?.secureMessageData)?.length > 0 &&
      websocketContext?.secureMessageData?.created_by_user_id === loggedInUserId &&
      websocketContext?.secureMessageData?.origin !== 'automation'
    ) {
      // Check if message was scheduled
      if (websocketContext?.secureMessageData?.body?.scheduled_status === 'scheduled') {
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.MESSAGE_SCHEDULED_SUCCESS);
      } else {
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.MESSAGE_SEND_SUCCESS);
      }
      websocketContext?.setSecureMessageData(null);
    }
  }, [websocketContext?.secureMessageData]);

  //Text message toast message
  useEffect(() => {
    if (
      websocketContext?.textMessageData &&
      Object.keys(websocketContext?.textMessageData)?.length > 0 &&
      websocketContext?.textMessageData?.notification_type !== 'outbound_status_callback' &&
      Boolean(websocketContext?.textMessageData?.only_thread_update) === false &&
      notificationList?.length > 0
    ) {
      // Check if this notification was already shown via notificationData to prevent duplicate toasts
      const textMessageNotificationId = websocketContext?.textMessageData?.sk;
      const shownNotifications = getShownNotifications();

      if (textMessageNotificationId && shownNotifications.has(textMessageNotificationId)) {
        // Clear the text message data since it was already processed
        websocketContext?.setTextMessageData(null);
        return;
      }
      addToast(
        false,
        toastConstant.toasterType.SUCCESS,
        toastConstant.api.SUCCESS,
        '',
        'bottom-right',
        true,
        websocketContext?.textMessageData
      );

      // Mark as shown to prevent duplicate
      if (textMessageNotificationId) {
        addShownNotification(textMessageNotificationId);
      }

      websocketContext?.setTextMessageData(null);
    }
  }, [websocketContext?.textMessageData]);

  //Automation error log message section
  useEffect(() => {
    if (websocketContext?.automationErrorLogData && Object.keys(websocketContext?.automationErrorLogData)?.length) {
      let { automationErrorLogData, setAutomationErrorLogData } = websocketContext || {};
      let notificationsArr = [...notificationList] || [];

      notificationsArr?.unshift(automationErrorLogData);
      setNotificationList((preval) => ({ ...preval, notifications: notificationsArr }));
      setNewNotification(true);

      addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, '', 'bottom-right', true, automationErrorLogData);

      // Clear the WebSocket data after showing the toast to prevent repeated toasts
      setAutomationErrorLogData(null);
    }
  }, [websocketContext?.automationErrorLogData]);

  /**--------------------------------------- useEffect section ends ---------------------------------------**/

  if (!showSideBar) return <div id="layout">{children}</div>;
  return (
    <div id="layout">
      {/* Overlay for faded background when navbar is open */}
      {navigationToggle && (
        <div
          className="navbar-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.4)',
            zIndex: 1040,
          }}
          onClick={() => setNavigationToggle(false)}
        />
      )}
      <OverlayPanel
        ref={notificationPanel}
        id="overlay_panel"
        style={{ width: '500px' }}
        className="overlaypanel-demo shadow p-1 notification-overlay"
        ariaCloseLabel="notification-panel"
      >
        {spinner}
        <div className="notification-wrapper overflow-hidden">
          <div className="pb-2 border-bottom rounded-0 notification-head mb-2">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2 align-items-center">
                <h6 className="text-bold m-0">Notifications</h6>
                <span className="text-muted">|</span>
                <a
                  href="/"
                  className={`text-decoration-none ${notificationFilter === 'unread' ? 'text-primary' : 'text-muted'}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setNotificationFilter('unread');
                    setCurrentToken('');
                    navbarContextData?.notificationData?.loadNotifications({
                      notificationType: '',
                      limit: 10,
                      is_read: false,
                      refresh: true,
                    });
                  }}
                >
                  <small>Unread</small>
                </a>
                <a
                  href="/"
                  className={`text-decoration-none ${notificationFilter === 'read' ? 'text-primary' : 'text-muted'}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setNotificationFilter('read');
                    setCurrentToken('');
                    navbarContextData?.notificationData?.loadNotifications({
                      notificationType: '',
                      limit: 10,
                      is_read: true,
                      refresh: true,
                    });
                  }}
                >
                  <small>Read</small>
                </a>
              </div>
              {notificationList?.length > 0 && (
                <a href="/" className="text-muted text-decoration-none" onClick={(e) => clearAll(e)}>
                  <small>Clear All</small>
                </a>
              )}
            </div>
          </div>

          {notificationList?.length > 0 ? (
            <InfiniteScrollList
              {...{
                notificationList,
                loadNotifications: (params) =>
                  navbarContextData?.notificationData?.loadNotifications({
                    ...params,
                    is_read: notificationFilter === 'read' ? true : false,
                  }),
                isLoading,
                markAsRead,
                nextToken,
                currentToken,
                setCurrentToken,
              }}
            />
          ) : (
            <div className="row mt-2">
              <div className="col-12 d-flex justify-content-center">No notifications found</div>
            </div>
          )}
        </div>
        <div className="pb-1 border-top rounded-0 mb-0">
          <div className="col-12 d-flex justify-content-end align-items-center m-0">
            <Link
              to="/profile?tab=settings"
              className="text-decoration-none call-back F-size13 text-medium mb-0 pointer"
              onClick={(e) => {
                notificationPanel?.current?.hide();
              }}
            >
              Notification Preferences
            </Link>
          </div>
        </div>
      </OverlayPanel>

      {websocketContext?.notificationPopup ? (
        <Notification
          visible={websocketContext?.notificationPopup}
          notificationData={websocketContext?.notificationData}
          onHide={() => websocketContext?.setNotificationPopup(false)}
        />
      ) : null}

      {/* Generic Notification Popup for toast/popup notifications */}
      {showNotificationPopup && notificationPopupData && (
        <NotificationPopup
          visible={showNotificationPopup}
          notificationData={notificationPopupData}
          onHide={() => {
            setShowNotificationPopup(false);
            setNotificationPopupData(null);
          }}
        />
      )}

      {userDetails?.selectedPlanDetails?.trial_end ? (
        <div className="d-flex align-items-center subscribe-msg justify-content-end px-3">
          {`Your free trial ${userDetails?.selectedPlanDetails?.status === 'completed' ? 'expires' : 'expired'} on ${moment
            .unix(userDetails?.selectedPlanDetails?.trial_end)
            .format('MM/DD/YYYY')}`}
          {userDetails?.access_level === 'firm-admin' && (
            <button
              className="p-button p-component p-button-secondary ms-3"
              onClick={() => {
                redirectToSubscription();
              }}
            >
              Subscribe Now
            </button>
          )}
        </div>
      ) : null}

      {/* Announcements - placed above nav bar and below subscription banner */}
      {!announcementsLoading && (
        <div className="container-fluid pt-0 px-0">
          <AnnouncementsBar items={announcementsData?.announcements} />
        </div>
      )}
      <nav className="navbar navbar-expand-lg px-2 py-3 position-relative" style={{ zIndex: 1050 }}>
        <div className="container-fluid flex-wrap">
          <button
            className="navbar-toggler me-2"
            type="button"
            data-toggle="collapse"
            data-target="#basicExampleNav"
            aria-controls="basicExampleNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => setNavigationToggle(!navigationToggle)}
          >
            <span className="navbar-toggler-icon d-flex align-items-center">
              <i className="fa fa-bars"></i>
            </span>
          </button>
          <Link to="/" className="text-dark fw-bold navbar-brand logo-wrap py-0 d-flex align-items-baseline">
            <img src={document.documentElement.getAttribute('data-theme') === 'dark' ? logodark : logo} alt="logo" width="88" />
          </Link>

          <div
            className={
              navigationToggle ? 'collapse navbar-collapse show' : 'collapse navbar-collapse lawfttop-navbar justify-content-center'
            }
            id="basicExampleNav"
          >
            <ul className="navbar-nav px-3">
              {/* {showModule('dashboard', 'common') && (
                <li className={classNames('nav-item', { active: pathname?.includes('/dashboard') })}>
                  {disableMenu ? (
                    <a className="nav-link disabledCursor" href="/" onClick={(e) => e.preventDefault()}>
                      Dashboard
                    </a>
                  ) : (
                    <a className="nav-link" href="/" onClick={redirectToDashboardPage}>
                      Dashboard
                    </a>
                  )}
                </li>
              )} */}

              {showModule('cases', 'case_management') && (
                <li className={classNames('nav-item', { active: pathname?.includes('/cases') })}>
                  {disableMenu ? (
                    <Link className="nav-link disabledCursor" to="/" onClick={(e) => e.preventDefault()}>
                      Cases
                    </Link>
                  ) : (
                    <Link className="nav-link" to="/cases" onClick={redirectToCases}>
                      Cases
                    </Link>
                  )}
                </li>
              )}

              {showModule('files', 'common') && (
                <li className={classNames('nav-item', { active: pathname?.includes('/file-manager') })}>
                  <>
                    <a
                      className={disableMenu ? 'nav-link disabledCursor' : 'nav-link'}
                      href="/"
                      onClick={(event) => {
                        event.preventDefault();
                        !disableMenu && fileMenu.current.toggle(event);
                      }}
                      aria-controls="popup_menu"
                      aria-haspopup
                    >
                      <div className="">
                        Files <i className="pi pi-chevron-down nav-down-arrow" />
                      </div>
                    </a>
                    <Menu model={documentItems?.filter((v) => v.show)} popup ref={fileMenu} id="popup_menu" />
                  </>
                </li>
              )}

              <li className={classNames('nav-item', { active: pathname === '/messages' })}>
                <a
                  className={disableMenu ? 'nav-link disabledCursor' : 'nav-link'}
                  href="/"
                  onClick={(event) => {
                    event.preventDefault();
                    if (!disableMenu) {
                      checkTagInStatus();
                      messagesMenu?.current?.toggle(event);
                      // Note: loadNotificationCount removed - it's handled by TextMessages component when needed
                    }
                  }}
                  aria-controls="popup_menu"
                  aria-haspopup
                >
                  <div>
                    Messages
                    {userDetails?.checkSubPermission('texting') &&
                    (secureMessageNotificationCount || texMessageNotificationcount || sidebarNotificationCount || mailNotificationCount) ? (
                      <i className="icon-window-filled pointer F-size12"></i>
                    ) : null}
                    <i className="pi pi-chevron-down nav-down-arrow" />
                  </div>
                </a>
                <Menu model={messageItemsFirmAdmin?.filter((v) => v.show)} popup ref={messagesMenu} id="popup_menu" />
              </li>

              {showModule('contacts', 'contact_management') && (
                <li className={classNames('nav-item', { active: /^\/contacts(?:\/|$)/.test(pathname) })}>
                  <Link
                    className={disableMenu ? 'nav-link disabledCursor' : 'nav-link'}
                    to={disableMenu ? '/' : '/contacts'}
                    onClick={(e) => {
                      disableMenu ? e.preventDefault() : setNavigationToggle(false);
                    }}
                  >
                    Contacts
                  </Link>
                </li>
              )}

              {showModule('calendar', 'calendaring') && (
                <li className={classNames('nav-item', { active: pathname === '/calendar' })}>
                  <Link
                    className={disableMenu ? 'nav-link disabledCursor' : 'nav-link'}
                    to={disableMenu ? '/' : '/calendar'}
                    onClick={(e) => {
                      disableMenu ? e.preventDefault() : setNavigationToggle(false);
                    }}
                  >
                    Calendar
                  </Link>
                </li>
              )}
              {showModule('tasks', 'task_management') && (
                <li className={classNames('nav-item', { active: pathname === '/tasks' })}>
                  <Link
                    className={disableMenu ? 'nav-link disabledCursor' : 'nav-link'}
                    to={disableMenu ? '/' : '/tasks'}
                    onClick={(e) => {
                      disableMenu ? e.preventDefault() : setNavigationToggle(false);
                    }}
                  >
                    Tasks
                    {Boolean(navbarContextData?.notificationData?.notificationCount?.task_count) && (
                      <i className="icon-window-filled pointer F-size12"></i>
                    )}
                  </Link>
                </li>
              )}

              {showModule('billing', 'common') && (
                <li className={classNames('nav-item', { active: pathname === '/billing' })}>
                  <Link
                    className={disableMenu ? 'nav-link disabledCursor' : 'nav-link'}
                    to={disableMenu ? '/' : '/billing'}
                    onClick={(e) => {
                      disableMenu ? e.preventDefault() : setNavigationToggle(false);
                    }}
                  >
                    Billing
                  </Link>
                </li>
              )}

              {showModule('leads', 'lead_management') && (
                <li className={classNames('nav-item', { active: pathname?.includes('/leads') })}>
                  <Link
                    className={disableMenu ? 'nav-link disabledCursor' : 'nav-link'}
                    to={disableMenu ? '/' : '/leads'}
                    onClick={(e) => (disableMenu ? e.preventDefault() : setNavigationToggle(false))}
                  >
                    Leads
                  </Link>
                </li>
              )}

              {showModule('reports', 'reports') && (
                <li className={classNames('nav-item', { active: pathname?.includes('/reports') })}>
                  <Link
                    className={disableMenu ? 'nav-link disabledCursor' : 'nav-link'}
                    to={disableMenu ? '/' : '/reports'}
                    onClick={(e) => (disableMenu ? e.preventDefault() : setNavigationToggle(false))}
                  >
                    Reports
                  </Link>
                </li>
              )}

              {/* {showModule('reports', 'reports') && ( */}
              <li className={classNames('nav-item', { active: pathname?.includes('/intake-forms') })}>
                <Link
                  className={disableMenu ? 'nav-link disabledCursor' : 'nav-link'}
                  to={disableMenu ? '/' : '/intake-forms'}
                  onClick={(e) => {
                    if (!disableMenu) {
                      setNavigationToggle(false);
                    }
                  }}
                >
                  Forms
                </Link>
              </li>
              {/* )} */}

              {showModule('automation', 'automated_repeatable_workflows') && (
                <li className={classNames('nav-item', { active: pathname?.includes('/workflow-automation') })}>
                  <Link
                    className={disableMenu ? 'nav-link disabledCursor' : 'nav-link'}
                    to={disableMenu ? '/' : '/workflow-automation'}
                    onClick={(e) => {
                      if (!disableMenu) {
                        setNavigationToggle(false);
                      }
                    }}
                  >
                    Automation
                  </Link>
                </li>
              )}
              <label className="mt-2 F-size12 bt-inner">
                <div className="d-flex align-items-center justify-content-between mobile-version-footer">
                  <div className="">Version</div>
                  <span className="version-no">v{appVersion}</span>
                </div>
              </label>
            </ul>
          </div>
          <div className="d-flex ms-auto align-items-center">
            <TimerManager />
            <div className="d-flex align-items-center ps-2">
              <Button
                className="p-button-outlined p-button-info top-button add-button"
                icon="pi pi-plus"
                onClick={(event) => menu.current.toggle(event)}
                aria-controls="popup_menu"
                aria-haspopup
                label=""
              />

              <Menu model={items.filter((v) => v.show)} popup ref={menu} id="popup_menu" />
            </div>
            <div className="d-flex align-items-center pe-lg-2 ps-lg-3 px-3 ms-3 global-search position-relative me-1 me-md-0">
              <GlobalSearch />
            </div>

            <div
              className="mr-4 ps-2 pe-3 d-flex align-items-center position-relative"
              aria-controls="notification-panel"
              onClick={(e) => {
                notificationPanel?.current?.toggle(e);
                setNewNotification(false);

                // Reset notification count
                resetNotificationCount()
                  .then(() => {
                    setWebSocketNotificationsCount(0);
                    // Update notification list state to reset total_notifications
                    setNotificationList((prev) => ({
                      ...prev,
                      total_notifications: 0,
                    }));
                    console.log('✅ Notification count reset successfully');
                  })
                  .catch((error) => {
                    console.error('❌ Error resetting notification count:', error);
                  });
              }}
            >
              <GlobalTooltip tooltip="Notifications" showDelay={500}>
                <i className={newNotification ? 'icon-notification bell fa-lg pointer' : 'icon-notification fa-lg pointer'} />
              </GlobalTooltip>

              {totalNotiicationsCount ? (
                <span className="notification-badge">{totalNotiicationsCount ? totalNotiicationsCount : null}</span>
              ) : null}
            </div>

            <li className="nav-item d-flex align-items-center">
              <>
                <a
                  className="nav-link d-flex align-items-center"
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    profileMenu.current.toggle(e);
                  }}
                  aria-controls="popup_menu"
                  aria-haspopup
                >
                  <Avatar image={imageUrl} onImageError={() => setImageUrl('')} className="me-1" size="medium" shape="circle" imageAlt="" />
                  <i className="pi pi-chevron-down nav-down-arrow" />
                </a>

                <Menu
                  model={[
                    { label: 'User Profile', url: '/#/profile', command: (e) => handleProfile(e.originalEvent), show: true },
                    ...(userDetails?.firmDetails?.firm_details?.length > 1
                      ? [{ label: 'Select Firm', command: () => firmSelectHandler(history), show: true }]
                      : []),
                    {
                      label: 'My Time',
                      url: '/#/reports/my-time',
                      command: (e) => redirectToPage(e.originalEvent, '/reports/my-time'),
                      show: true,
                    },
                    {
                      label: 'Firm Settings',
                      url: '/#/settings/team-management',
                      command: (e) => redirectToPage(e.originalEvent, '/settings/team-management'),
                      show: true,
                    },
                    {
                      label: 'Logout',
                      command: (e) => {
                        e.originalEvent.preventDefault();
                        handleLogout();
                      },
                      show: true,
                    },
                  ].filter((item) => item.show)}
                  popup
                  ref={profileMenu}
                  id="popup_menu"
                />
              </>
            </li>
          </div>
        </div>
      </nav>
      <div className="content-container pt-3" style={{ height: dynamicHeight, overflow: 'auto' }}>
        <div className="container-fluid">
          <UserProfileContext.Provider
            value={{
              userInfo: userInfo,
              fetchUserDetails: fetchUserDetails,
              setImageUrl: setImageUrl,
            }}
          >
            {children}
          </UserProfileContext.Provider>
        </div>
      </div>

      <Dialog
        className="new-task-popup"
        header={ModalHeader}
        visible={isFileVisible}
        style={{ width: '40vw' }}
        footer={<></>}
        onHide={() => setFileVisible(false)}
      >
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="modal-heading F-size16 text-bold">Add Document</div>
          </div>
          <div className="d-flex justify-content-center align-items-center mb-4">
            <Link
              onClick={() => {
                setFileVisible(false);
              }}
              to="/file-manager"
              className="file-shortcut-button card-bg d-flex flex-column  justify-content-center align-items-center me-4 text-decoration-none"
            >
              <i className="fas fa-file-upload fa-5x"></i>
              <span className="text-center black-700"> Upload one document</span>
            </Link>
            <Link
              onClick={() => {
                setFileVisible(false);
              }}
              to="/file-manager"
              className="file-shortcut-button card-bg d-flex flex-column justify-content-center align-items-center ms-4 text-decoration-none"
            >
              <i className="fas fa-copy fa-5x"></i>
              <span className="text-center black-700"> Upload multiple documents</span>
            </Link>
          </div>
          {userDetails.checkSubPermission('document_assembly') && (
            <div className="d-flex justify-content-center align-items-enter mt-4">
              <Link
                onClick={() => {
                  setFileVisible(false);
                }}
                to="/templates"
                className="file-shortcut-button card-bg d-flex flex-column justify-content-center align-items-center me-4 text-decoration-none"
              >
                <i className="fas fa-file-word fa-5x"></i>
                <span className="text-center black-700">Create document from template</span>
              </Link>

              <a
                href="#"
                // href={`/#/templates/builder?type=scratch&save_as=file&from=${encodeURIComponent(history.location?.pathname)}`}
                onClick={(e) => {
                  e.preventDefault();
                  setNameModal(true);
                  reset();
                }}
                className="file-shortcut-button card-bg d-flex flex-column justify-content-center align-items-center ms-4 text-decoration-none"
              >
                <i className="fas fa-file fa-5x"></i>
                <div className="d-flex justify-content-center align-items-center">
                  <span className="text-center black-700">Start with a blank page</span>
                </div>
              </a>
            </div>
          )}
        </div>
      </Dialog>

      <Dialog
        className="new-task-popup"
        footer={
          <div className="mt-2">
            <Button label="Cancel" className="p-button-secondary outline mx-2" onClick={() => setNameModal(false)} />
            <Button label="Create" className="p-button-secondary  mx-2" onClick={() => handleSubmit(handleFromScratch)()} />
          </div>
        }
        visible={nameModal}
        style={{ width: '40vw' }}
        modal
        closable={false}
        header={customHeaderTemplate}
        onHide={() => setNameModal(false)}
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="modal-heading F-size16 text-bold">Template Name</div>
        </div>

        <Controller
          name="file_name"
          control={control}
          render={({ field }) => (
            <TextSnippetWrapper
              value={field.value}
              onChange={(e) => field.onChange(e.target.value)}
              type="text"
              rows={4}
              cols={30}
              autoResize
              className="mt-2 w-100 input-shadow "
              placeholder="File name"
            />
          )}
        />
        {errors.file_name && <small className="p-error ms-1">{errors.file_name?.message}</small>}
      </Dialog>
    </div>
  );
};

export default Layout;
